import { MetadataCollector, MetadataKey, Metadata } from './metadata';
import EventMetadataCollector from './eventMetadataCollector';

const metadataCollector: MetadataCollector = new EventMetadataCollector();

export default metadataCollector;

export type { MetadataKey, Metadata };
